import(/* webpackMode: "eager" */ "/codebuild/output/src3584820406/src/apps/webapp/src/app/global-error.tsx");
